import React from 'react';
import { createRoot } from '@/util/hmr';

import { AppContainer } from '@/exceed';

import { App } from '@/unifiedSearch';

if (import.meta.hot) import.meta.hot.accept();

const root = createRoot(document.querySelector('.js-react-unified-search'));

root.render(
  <AppContainer config={{ i18nKey: 'unified_search' }}>
    <App />
  </AppContainer>,
);
